import m, {Vnode} from "mithril";
import Messages from "./../../model/messages";
import {CellItem} from "../../model/items/cellItem";
const s = require("underscore.string");

export default class FileInput {
    constructor(
        private readonly accept: string = '*',
        private readonly fileChosenCallback: (content: string, file: File) => void,
        private readonly messages: Messages,
        private readonly variable: CellItem|null = null
    ) { }


    public view(): Vnode {
        const buttonText = (this.variable && this.variable.getVariable()) ? 'pickupMoreFiles' : 'pickupFile';

        return m('label', {
                onclick: () => {
                    // unset active global unknown before picking file
                    this.variable?.form.activeGlobalUnknown?.set();
                },
            }, [
                this.viewInput(),
                m('i.icon.icon-file', {}, ''),
                m('span', {}, this.messages.get(buttonText))
            ]
        );
    }

    private viewInput(): Vnode {
        return m('input', {
            type: 'file',
            accept: this.accept,
            multiple: true,
            disabled: this.variable ? !this.variable.cell.enabled : false,
            onchange: (e: InputEvent) => {
                const input = <HTMLInputElement>e.currentTarget;
                if (!input.files) {
                    return;
                }
                for (let i=0; i<input.files.length; i++) {
                    if (input.files[i].size < 20*1024*1024 && s(input.files[i].type).startsWith("image")) {
                        const reader = new FileReader();
                        reader.onload = (readerEvent: ProgressEvent) => {
                            const fileContent = (<FileReader>readerEvent.target).result;
                            if (fileContent) {
                                this.fileChosenCallback(String(fileContent), input.files![i]);
                            }
                        };
                        reader.readAsDataURL(input.files[i]);
                    } else {
                        this.fileChosenCallback('', input.files[i]);
                    }
                }

            },
        });
    }
}
